module.exports = __webpack_public_path__ + "img/loading_red.3f384382.svg";